export default __webpack_public_path__ + "378f09ff5828a8623951595572e3154f.png";